import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Typewriter } from "react-simple-typewriter";
import AOS from "aos";
import "aos/dist/aos.css";
import codewars from "../../../Assets/logo/codewars.png";
import { BsGithub } from "react-icons/bs";
import {
  FaFacebook,
  FaLinkedin,
  FaFacebookMessenger,
  FaTelegram,
  FaCode,
} from "react-icons/fa";

const Banner = () => {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <div>
      <div className="hero mt-[10%]">
        <div className="hero-content flex-col lg:flex-row gap-10">
          <div>
            <img
              data-aos="fade-right"
              data-aos-duration="1500"
              src="https://avatars.githubusercontent.com/u/72511886?v=4"
              className="w-[200px] md:w-[250px] lg:w-[750px] rounded-full border-4 border-cyan-700 shadow-2xl lg:mr-10"
              alt=""
            />
          </div>
          <div data-aos="fade-left" data-aos-duration="1500">
            <h1 className="text-3xl font-semibold mb-4">Hello</h1>
            <h1 className="text-xl font-medium mb-6">I'm</h1>
            <h1 className="text-5xl font-bold mb-5">Md. Shahriar Rahman</h1>
            <h1 className="text-3xl font-semibold text-blue-400">
              <Typewriter
                words={[
                  "FrontEnd Web Developer",
                  "NextJs Developer",
                  "MERN Stack Developer",
                  "Programmer",
                  "Problem Solver",
                ]}
                loop={50}
                cursor
                cursorStyle="_"
                typeSpeed={100}
                deleteSpeed={50}
                delaySpeed={1000}
              />
            </h1>
            <p className="py-6 mb-6">
              Frontend Developer with experience of building sites from scratch,
              full responsive web site with ReactJs, NextJs as Frontend ,MongoDB
              as database, ExpressJs, NodeJs as Backend.{" "}
              <span className="font-semibold text-red-500">CodeWars</span>{" "}
              Problem Solver, 40+ Easy,Medium Solves, ranking 5 kyu -{" "}
              <a
                className="underline text-blue-300 font-semibold "
                href="https://www.codewars.com/users/siamshahriar"
                target="_blank"
                rel="noreferrer"
              >
                Profile
              </a>
              <br />
            </p>

            <div className="flex flex-col lg:flex-row lg:items-center gap-4">
              <div className="flex justify-center gap-3">
                <a
                  href="https://drive.google.com/file/d/1n0G8yXAuZLZvbOaiHhEHIzpdCkk9FPVj/view?usp=share_link"
                  target="_blank"
                  className="btn btn-success text-white"
                  rel="noreferrer"
                >
                  Resume
                </a>
                <Link to="/contact" className="btn btn-outline text-white">
                  Contact
                </Link>
              </div>

              <div className="flex gap-2 justify-center">
                <a
                  className="text-4xl"
                  href="https://www.linkedin.com/in/siam-shahriar/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaLinkedin></FaLinkedin>
                </a>
                <a
                  className="text-4xl"
                  href="https://github.com/siamshahriar"
                  target="_blank"
                  rel="noreferrer"
                >
                  <BsGithub></BsGithub>
                </a>{" "}
                <a
                  className="text-4xl"
                  href="https://www.facebook.com/mdshahriarrahman.siam/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaFacebook></FaFacebook>
                </a>
                <a
                  className="text-4xl"
                  href="https://m.me/mdshahriarrahman.siam/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaFacebookMessenger></FaFacebookMessenger>
                </a>
                <a
                  className="text-4xl"
                  href="https://t.me/siaamdiu"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaTelegram></FaTelegram>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
